import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col,
    Card,
    CardImg
} from "reactstrap";
import Link from 'next/link';
import { useRouter } from 'next/router';
import styles from './styles.module.scss';
import Pagination from '../../components/Pagination';
import useCampaignBlogs from "../../hooks/useCampaignBlogs";

const ITEMS_PER_PAGE = 9;

export const AllBlogs = ({
    customClass,
    buttonTitle,
    heading,
    isAllBlogsPage = true,
    enablePagination = true,
    enableHeading,
    pageLink,
}) => {
    const router = useRouter();
    const currentPageNum = parseInt(router.query.page || '1', 10);

    const all_blogs = useCampaignBlogs();
    const displayed_blogs = all_blogs?.slice(3) ?? [];

    const totalPages = Math.ceil(displayed_blogs.length / ITEMS_PER_PAGE);
    const all_paginations = Array.from({ length: totalPages }, (_, i) => ({ params: { page: i + 1 } }));
    const all_currentPage = {
        current: currentPageNum,
        previous: currentPageNum > 1 ? currentPageNum - 1 : null,
        next: currentPageNum < totalPages ? currentPageNum + 1 : null,
    };

    const startIndex = (currentPageNum - 1) * ITEMS_PER_PAGE;
    const paginatedBlogs = displayed_blogs.slice(startIndex, startIndex + ITEMS_PER_PAGE);

    return (
        paginatedBlogs?.length >= 1 && (<section className={`${styles.root} ${customClass}`}>
            <Container>
                <div className={`content-wrapper isBlogPage`}>
                    {heading && enableHeading ?
                        <h2 className="text-center mb-5">{heading} </h2> : ""}
                    <Row>
                        {isAllBlogsPage ?
                            <>
                                {paginatedBlogs?.map((post, index) => (
                                    <Col md={12} key={index} className="mb-0 mb-md-4 mb-lg-0">
                                        <Link href={`/${post.url_pattern}/${post.url_slug}`}>
                                            <a className="text-decoration-none d-block h-100">
                                                <Card className="p-2 border flex-wrap justify-content-between rounded-3 overflow-hidden d-flex mb-4">
                                                    <div className="d-flex flex-nowrap align-items-start align-items-md-center">
                                                        <div className="img-wrapper rounded-3 overflow-hidden">
                                                            <SourceFlowImage
                                                                src={post?.image?.en ? post.image.en : "/site-assets/images/image-placeholder.webp"}
                                                                size="600x600"
                                                                alt={post?.title?.en}
                                                                className="card-img"
                                                                width="100%"
                                                                height="100%"
                                                            />
                                                        </div>
                                                        <h5 className="post-title m-0  ps-3 ps-md-5 pe-2 pe-md-5">{post?.title?.en}</h5>
                                                    </div>
                                                    <div className="mt-4 text-end">
                                                        <span className="primaryBtn">{buttonTitle}</span>
                                                    </div>
                                                </Card>
                                            </a>
                                        </Link>
                                    </Col>
                                ))}
                                {enablePagination && all_paginations.length > 1 && (
                                    <Pagination pagination={all_paginations} currentPage={all_currentPage} pageLink={pageLink} />
                                )}
                            </> : <>
                                {paginatedBlogs?.map((post, index) => (
                                    <Col xs={12} lg={4} key={index} className="mb-4 mb-lg-0">
                                        <Link href={`/${post.url_pattern}/${post.url_slug}`}>
                                            <a className="text-decoration-none d-block h-100">
                                                <Card className="p-2 border justify-content-between rounded-3 overflow-hidden h-100">
                                                    <div>
                                                        <div className="img-wrapper rounded-3 overflow-hidden">
                                                            <SourceFlowImage
                                                                src={post?.image?.en ? post.image.en : "/site-assets/images/image-placeholder.webp"}
                                                                size="1000x400"
                                                                alt={post?.title?.en}
                                                                className="card-img"
                                                                width="100%"
                                                                height="100%"
                                                            />
                                                        </div>
                                                        <h5 className="post-title mt-4 ps-3 pe-3">{post?.title?.en}</h5>
                                                    </div>
                                                    <div className="mt-4 text-end">
                                                        <span className="primaryBtn">{buttonTitle}</span>
                                                    </div>
                                                </Card>
                                            </a>
                                        </Link>
                                    </Col>
                                ))}
                            </>}
                    </Row>
                </div>
            </Container>
        </section>
        )
    )
}

export default AllBlogs;
